import { setTrackingId } from "client/Misc/utils";
import { forwardRef, ReactElement, Ref } from "react";
import classNames from "classnames";
import styles from "./RoundButton.module.less";
import { FontIconName, Icon } from "../Icon/Icon";
import { useCallbackWithoutArguments } from "client/Hooks";

export type RoundButtonProps = {
	icon: FontIconName;
	isActive?: boolean;
	onClick: () => void;
	trackingId?: string;
};

export const RoundButton = forwardRef<HTMLButtonElement, RoundButtonProps>(
	(props: RoundButtonProps, ref: Ref<HTMLButtonElement>): ReactElement => {
		const {
			icon,
			isActive = false,
			onClick: onClickFromProps,
			trackingId
		} = props;

		const onClick: () => void = useCallbackWithoutArguments(onClickFromProps);

		return (
			<button
				{...setTrackingId(trackingId)}
				className={classNames(
					styles.root,
					{[styles.root_active]: isActive}
				)}
				onClick={onClick}
				ref={ref}
			>
				<Icon value={icon} />
			</button>
		);
	}
);

RoundButton.displayName = "RoundButton";